import React from 'react'
import PropTypes from 'prop-types'
import AdminDashboardBanner from 'components/AdminDashboardBanner'
import {
  BodyWrapper,
  PageWrapper,
  ContentPanelWrapper,
} from './component.styles'

const K8Tier2LessonCompletion = ({
  gradeBand,
  isSetup,
  selectedProgram,
  siteId,
}) => {
  if (!siteId) return null

  return (
    <PageWrapper>
      <BodyWrapper>
        <AdminDashboardBanner selectedProgram={selectedProgram} />

        <ContentPanelWrapper>
          <h2>Tier 2 Lesson Completion - Interventions</h2>
          <p>This is the Interventions page using AdminDashboardBanner.</p>
          <p>Site ID: {siteId}</p>
          <p>Grade Band: {gradeBand}</p>
        </ContentPanelWrapper>
      </BodyWrapper>
    </PageWrapper>
  )
}

K8Tier2LessonCompletion.propTypes = {
  gradeBand: PropTypes.string,
  isSetup: PropTypes.bool,
  selectedProgram: PropTypes.object,
  siteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default K8Tier2LessonCompletion
